var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel4",staticStyle:{"padding":"10px"}},[_c('div',{staticStyle:{"margin":"0 auto","width":"200px"}},[_c('i',{staticClass:"el-icon-loading"}),_vm._v("数据读取中... ")])])
}]

export { render, staticRenderFns }